import {
  CLASSIC,
  COMPREHENSIVE,
  PRODUCT,
  SECONDARY_PRODUCT,
} from "@/constants";

const coverLevels = {
  staysure: COMPREHENSIVE,
  avanti: CLASSIC,
  expat: COMPREHENSIVE,
};

const brand: "staysure" | "avanti" | "expat" =
  SECONDARY_PRODUCT === "expat"
    ? "expat"
    : (PRODUCT as "staysure" | "avanti") ?? "staysure";

const defaultCoverLevel = coverLevels[brand];

export default defaultCoverLevel;
